import React from 'react'
export const IconImages = () => <ion-icon id="img_open_formpage_icon" name="images-outline" />
